import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment as any);

import {AppModule} from '@app/app.module';
import {environment} from '@environment';
import {AppUtils} from '@app/shared/utils/app-utils';

AppUtils.ajax('environment.json', 'get', obj => {
  const configObj: any = JSON.parse(obj.responseText);
  console.log(`Starting app v${environment.version}...`);

  for (const attrname in configObj) {
    if (configObj.hasOwnProperty(attrname)) {
      (environment as any)[attrname] = typeof (window as any)[attrname] === 'undefined' ? configObj[attrname] : (window as any)[attrname];
    }
  }
  if (environment.production) {
    enableProdMode();
  }
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
